import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useCart } from "react-use-cart";
import Hero from "../components/Hero";
import { formatPrice } from "../utils/helper";
import { useOrderContext } from "../context/OrderContext";

export default function Checkout() {
  const navigate = useNavigate();
  const { items, cartTotal } = useCart();
  const {createOrder} = useOrderContext();

  const [formData, setFormData] = useState({
    // firstName: "",
    // lastName: "",
    // email: "",
    phone: "",
    address: "",
    // apartment: "",
    // city: "",
    // country: "",
    postal_code: "",
    country: "",
    // saveInfo: false,
    promoCode: "",
  });
  const storedUser = JSON.parse(localStorage.getItem("user"));

  const [promoApplied, setPromoApplied] = useState(false);

  const shipping = 15000;
  const discount = promoApplied ? cartTotal * 0.15 : 0;
  const grandTotal = cartTotal - discount + shipping;

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleApplyPromo = () => {
    if (formData.promoCode.trim().toUpperCase() === "LOVEYOURSELF") {
      setPromoApplied(true);
    } else {
      alert("Invalid promo code");
    }
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    console.log("🧾 Raw cart items:", items);

    const updateData = {
      ...formData,
      products: items
        .map((item) => {
          const variantId =
            item.variantId ||                           // if already set
            item.selectedVariant?.id ||                 // if set during product detail
            item.variants?.[0]?.id ||                   // fallback to first variant
            null;

          if (!variantId) {
            console.warn("❌ Skipping item with missing variant ID:", item);
            return null;
          }

          return {
            id: variantId,
            quantity: item.quantity,
          };
        })
        .filter(Boolean), // removes any null items
    };

    console.log("📦 Final checkout payload:", updateData);

    const response = await createOrder(updateData);
    console.log("🧾 Response from createOrder:", response.data);

    // Redirect to payment gateway or confirmation
    if (response?.data?.redirect_url) {
      window.location.href = response.data.redirect_url;
    } else {
      navigate("/thank-you");
    }

  } catch (err) {
    console.error("Checkout error:", err);
    alert("Something went wrong while processing your order. Please try again.");
  }
};

  if (items.length === 0) {
    return (
      <div className="bg-[#fef8f5] min-h-screen">
        <Hero
          title={"Checkout"}
          description={"Review your order before completing your purchase"}
          image={
            "https://img.freepik.com/free-photo/pink-empty-shopping-basket-online-shopping-concept-pink-background-3d-rendering_56104-1527.jpg"
          }
        />
        <div className="max-w-7xl mx-auto px-4 py-16 text-center">
          <h2 className="text-2xl font-bold text-[#7a6e5f] mb-4">
            Your cart is empty
          </h2>
          <button
            onClick={() => navigate("/products")}
            className="mt-4 text-[#809080] hover:underline inline-flex items-center gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            Continue Shopping
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-[#fef8f5]">
      <Hero
        title={"Checkout"}
        description={"Your final step to glowy skin starts here"}
        image={
          "https://img.freepik.com/free-photo/surprised-girl-pink-culottes-posing-with-trolley-full-multi-colored-packages-with-new-clothes_197531-14251.jpg?t=st=1745422292~exp=1745425892~hmac=ebfc0790d1cc2ee8423d74a9dfdef1495c40f68bdf48d5006d6cb765d9d958f2&w=996"
        }
      />
      <div className="max-w-6xl mx-auto px-4 py-16">
        <button
          onClick={() => navigate("/cart")}
          className="mb-8 text-[#809080] hover:underline inline-flex items-center gap-2"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to Cart
        </button>

        <form onSubmit={handleSubmit} className="grid md:grid-cols-2 gap-10">
  {/* Left Column: Shipping Information */}
  <div>
    <h2 className="text-2xl font-semibold mb-6 text-[#7a6e5f]">
      Shipping Information
    </h2>
    <div className="space-y-6">

      {/* Phone */}
      <div>
        <label htmlFor="phone" className="block mb-2 text-sm font-medium text-[#7a6e5f]">
          Phone Number
        </label>
        <input
          type="text"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
          required
          placeholder="+62 812-3456-7890"
          className="w-full px-4 py-3 border border-[#f5eee6] rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-[#809080]"
        />
      </div>

      {/* Address */}
      <div>
        <label htmlFor="address" className="block mb-2 text-sm font-medium text-[#7a6e5f]">
          Address
        </label>
        <input
          type="text"
          name="address"
          value={formData.address}
          onChange={handleChange}
          required
          placeholder="Street address"
          className="w-full px-4 py-3 border border-[#f5eee6] rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-[#809080]"
        />
      </div>

      {/* Postal Code */}
      <div>
        <label htmlFor="postalCode" className="block mb-2 text-sm font-medium text-[#7a6e5f]">
          Postal Code
        </label>
        <input
          type="text"
          name="postal_code"
          value={formData.postal_code}
          onChange={handleChange}
          required
          placeholder="Postal Code"
          className="w-full px-4 py-3 border border-[#f5eee6] rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-[#809080]"
        />
      </div>

<div>
        <label htmlFor="postalCode" className="block mb-2 text-sm font-medium text-[#7a6e5f]">
          Country
        </label>
        <input
          type="text"
          name="country"
          value={formData.country}
          onChange={handleChange}
          required
          placeholder="Country"
          className="w-full px-4 py-3 border border-[#f5eee6] rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-[#809080]"
        />
      </div>

    </div>
  </div>

          {/* Right Column: Order Summary */}
<div className="bg-white p-8 rounded-2xl shadow-md space-y-6 h-fit border border-[#f5eee6]">
  <h2 className="text-2xl font-semibold text-[#7a6e5f] mb-6">
    Order Summary
  </h2>

  <ul className="text-sm text-[#7a6e5f] space-y-3">
    {items.map((item) => (
      <li key={item.id} className="flex justify-between items-center">
        <span className="truncate">{item.name} × {item.quantity}</span>
        <span className="font-medium">{formatPrice(item.price * item.quantity)}</span>
      </li>
    ))}
  </ul>

  <div className="border-t border-[#f5eee6] pt-4 space-y-3 text-[#7a6e5f] text-sm">
    <div className="flex justify-between">
      <span>Subtotal</span>
      <span>{formatPrice(cartTotal)}</span>
    </div>
    <div className="flex justify-between">
      <span>Shipping</span>
      <span>{formatPrice(shipping)}</span>
    </div>
    {promoApplied && (
      <div className="flex justify-between text-[#809080] font-medium">
        <span>Promo Discount</span>
        <span>-{formatPrice(discount)}</span>
      </div>
    )}
    <div className="flex justify-between text-base font-bold pt-2 border-t border-[#f5eee6]">
      <span>Total</span>
      <span>{formatPrice(grandTotal)}</span>
    </div>
  </div>

  {/* Promo Code */}
  <div className="space-y-3">
    <input
      type="text"
      name="promoCode"
      value={formData.promoCode}
      onChange={handleChange}
      placeholder="Promo Code (e.g. LOVEYOURSELF)"
      className="w-full px-4 py-2 border border-[#f5eee6] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#809080] bg-white text-[#7a6e5f]"
    />
    <button
      type="button"
      onClick={handleApplyPromo}
      className="w-full bg-[#809080] hover:bg-[#6d7d6d] text-white py-2 rounded-lg font-medium transition"
    >
      Apply Promo
    </button>
  </div>

  {/* Submit Button */}
  <button
    type="submit"
    className="w-full mt-4 bg-[#7a6e5f] hover:bg-[#6d5e4d] text-white py-3 rounded-lg font-semibold transition"
  >
    Complete Purchase
  </button>
</div>
        </form>
      </div>
    </div>
  );
}